import {
  List,
  TextField,
  EditButton,
  ShowButton,
  Datagrid,
  SimpleList,
  TextInput,
  FunctionField,
  Button,
  useRedirect,
  TopToolbar,
  CreateButton,
} from "react-admin";
import ScoreFormulaForm from "./ScoreFormula/ScoreFormulaForm";
import { checkPermission } from "server/security/utils";
import { getPermissions } from "auth/security/securityUtils";
import permissions from "app/permissions";
import { AdministrationServicePath, ANNUAL_FEES, MOBILE_BREAKPOINT, SPECIALITIES } from "utils/constants";
import { Grid, useMediaQuery } from "@mui/material";
import { EmptyList } from "server/components";
import { settings } from "app";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import GroupSpecificationForm from "./GroupSpecification/GroupSpecificationForm";
import StreamsSpecificationForm from "./StreamsSpecification/StreamsSpecificationForm";
import WeeksSpecificationForm from "./WeeksSpecification/WeeksSpecificationForm";
import SecuredComponent from "server/security/SecuredComponent";
import { EducationsExporter } from "../XlsxExporter";
import { ExportXlsButton } from "features/ExportXlsxButton";
import { MobileListRow } from "features/MobileListRow";
import { tenants } from "utils/tenants";

const filters = [
  <TextInput
    label="Име"
    source="name"
    style={{ width: 300 }}
    alwaysOn
  />,
];

const ListSpecialities = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const redirect = useRedirect();
  const userPermissions = getPermissions();

  const ListActions = hasCreate => {
    return (
      <TopToolbar>
        {hasCreate && <CreateButton />}
        <ExportXlsButton exporter={EducationsExporter(SPECIALITIES)} />
      </TopToolbar>
    );
  };

  return (
    <List
      title="Специалности"
      filters={filters}
      actions={<ListActions hasCreate={checkPermission(userPermissions, permissions.canCreateSpecialities)} />}
    >
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => (
            <MobileListRow fields={[{ label: "Име на български език", value: record.nameBg }]} />
          )}
          secondaryText={record => (
            <div>
              <MobileListRow fields={[{ label: "Име на английски език", value: record.nameEn }]} />
              <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                <SecuredComponent
                  permission={permissions.canPreivewSpecialityStudyWeeks && permissions.canUpdateSpecialityStudyWeeks}
                >
                  <WeeksSpecificationForm />
                </SecuredComponent>

                <SecuredComponent permission={permissions.canPreviewSpecialitiesScoreFormulas}>
                  <ScoreFormulaForm label="" />
                </SecuredComponent>

                <SecuredComponent
                  permission={
                    permissions.canUpdateSpecialityGroupSpecifications &&
                    permissions.canPreviewSpecialityGroupSpecifications
                  }
                >
                  <GroupSpecificationForm />
                </SecuredComponent>

                {settings.tenant === tenants.MU && (
                  <SecuredComponent
                    permission={
                      permissions.canPreviewSpecialityStreamSpecifications &&
                      permissions.canUpdateSpecialityStreamSpecifications
                    }
                  >
                    <StreamsSpecificationForm />
                  </SecuredComponent>
                )}
                <SecuredComponent permission={permissions.canPreviewAnnualFees}>
                  <Button
                    startIcon={<AttachMoneyIcon />}
                    label="Такси"
                    onClick={() =>
                      redirect(`/${AdministrationServicePath}${SPECIALITIES}/${ANNUAL_FEES}/${record.id}/edit`)
                    }
                  />
                </SecuredComponent>
              </div>
            </div>
          )}
          tertiaryText={() => (
            <>
              <SecuredComponent permission={permissions.canUpdateSpecialities}>
                <EditButton label="" />
              </SecuredComponent>
              <ShowButton label="" />
            </>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
        >
          <TextField
            source="nameBg"
            label="Име на български език"
            sortable={false}
          />
          <TextField
            source="nameEn"
            label="Име на английски език"
            sortable={false}
          />
          <Grid sx={{ display: "flex", flexDirection: "column", gap: 1, alignItems: "start" }}>
            <SecuredComponent
              permission={
                permissions.canUpdateSpecialityGroupSpecifications &&
                permissions.canPreviewSpecialityGroupSpecifications
              }
            >
              <GroupSpecificationForm />
            </SecuredComponent>

            {settings.tenant === tenants.MU && (
              <SecuredComponent
                permission={
                  permissions.canPreviewSpecialityStreamSpecifications &&
                  permissions.canUpdateSpecialityStreamSpecifications
                }
              >
                <StreamsSpecificationForm />
              </SecuredComponent>
            )}
          </Grid>
          <Grid sx={{ display: "flex", flexDirection: "column", gap: 1, alignItems: "start" }}>
            <SecuredComponent
              permission={permissions.canPreivewSpecialityStudyWeeks && permissions.canUpdateSpecialityStudyWeeks}
            >
              <WeeksSpecificationForm />
            </SecuredComponent>
            <SecuredComponent permission={permissions.canPreviewSpecialitiesScoreFormulas}>
              <ScoreFormulaForm />
            </SecuredComponent>
          </Grid>
          <SecuredComponent permission={permissions.canPreviewAnnualFees}>
            <FunctionField
              render={rec => (
                <Button
                  startIcon={<AttachMoneyIcon />}
                  label="Такси"
                  onClick={() => redirect(`/${AdministrationServicePath}${SPECIALITIES}/${ANNUAL_FEES}/${rec.id}/edit`)}
                />
              )}
            />
          </SecuredComponent>
          <SecuredComponent permission={permissions.canUpdateSpecialities}>
            <EditButton />
          </SecuredComponent>
          <ShowButton />
        </Datagrid>
      )}
    </List>
  );
};
export default ListSpecialities;
